import { IconProps } from "./types";

export default function IcoArrowUp({
	color = "#FFF",
	width = "12",
	height = "15"
}: IconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 12 15"
			fill="none"
		>
			<g clipPath="url(#clip0_650_2257)">
				<path
					d="M6.55557 1.88184C6.21377 1.54004 5.65869 1.54004 5.3169 1.88184L0.941895 6.25684C0.600098 6.59863 0.600098 7.15371 0.941895 7.49551C1.28369 7.8373 1.83877 7.8373 2.18057 7.49551L5.0626 4.61074V12.9998C5.0626 13.4838 5.45361 13.8748 5.9376 13.8748C6.42158 13.8748 6.8126 13.4838 6.8126 12.9998V4.61074L9.69463 7.49277C10.0364 7.83457 10.5915 7.83457 10.9333 7.49277C11.2751 7.15098 11.2751 6.5959 10.9333 6.2541L6.5583 1.8791L6.55557 1.88184Z"
					fill={color}
				/>
			</g>
			<defs>
				<clipPath id="clip0_650_2257">
					<path d="M0.6875 0.75H11.1875V14.75H0.6875V0.75Z" fill={color} />
				</clipPath>
			</defs>
		</svg>
	);
}
